define([
    "jwplayer",
    "templates/activityhelper-template.handlebars",
    "underscore",
    "less/activityhelper.less"
],function(jwplayer, _template, _){

    var echarts = window.echarts
    if (window.activityhelperCount) {
      window.activityhelperCount += 1
    } else {
      window.activityhelperCount = 0
    }
    var c = window.activityhelperCount
    var pluginName = 'activityhelper'
    var heightRadio = 0.23
    module.exports = jwplayer().registerPlugin(pluginName, '6.0',
      function(player, config, activityhelper){
          var defaultOptions = {
            dockname: 'activity',
            id: 'activityID_' + c,
            showOrHide: -1,
            file: '',
            title: 'title',
            lang: {
              person: '人'
            }
          }
          var o  = $.extend(defaultOptions,config);
          var showOrHide = o.showOrHide
          var duration, currentArr
          var $wrapper = $(activityhelper);
          var _w = 0, _h = 0

          console.log(config)
          var echart, echartOptions

          var setup = function(e){
            var aArr = {}
            var handleResponse = function (e){

               $xml = $(e)
               var firstGuid = "";
               $xml.find("items").each(function(idx, items){
                    var guid = $(items).attr("guid") || $(items).attr("id") || 'default';
                    aArr[guid] = [];
                    if(idx == 0 ) firstGuid = guid;
                    var tempArr=[];

                    $(items).find("item").each(function(i,item){

                        // tempArr.push({
                        //     count: parseInt($(item).find("count").text()),
                        //     seekTime: parseInt($(item).find("time").text())/1000
                        // });
                        tempArr.push([
                          parseInt($(item).find("time").text())/1000,
                          parseInt($(item).find("count").text())
                        ]);
                    });

                    aArr[guid] = tempArr;
                })

                currentArr = aArr[firstGuid];
                console.log('currentArr: ', currentArr)
                var thtml = _template({
                    cuePointsArr: currentArr,
                    o: o,
                    isEmpty: currentArr.length ? true:false
                });

                $wrapper.append(thtml);

            }
            $.ajax(o.file, {
                // dataType: 'text/xml',
                dataType: 'xml',
                success:function(e){
                    handleResponse.call(this,e);
                },
                error: function(e,reason){
                    if(e.status == 200){
                        handleResponse.call(this,e.responseText);
                    }else{
                        $wrapper.html(reason)
                    }
                }
            });
            $(document).on("click", ".close-btn",function(e){
              console.log('click close')
               hide();
               showOrHide *= -1;
           });
          }

          player.onReady(setup);
          player.onMeta(function (m){
            // console.log(m)
            if (m.duration || (m.metadata && m.metadata.duration)){
              if(m.metadata){
                  duration =  m.metadata.duration
              } else {
                  duration = m.duration
              }
              var newArr = _.filter(currentArr, function(arr){
                return arr[0] <= duration
              })
              newArr.push([duration, newArr[newArr.length - 1][1]])
              echartOptions = {
                // backgroundColor: '#fcfcfc',
                title: {
                  show: false
                  // padding: 10,
                  // left: 0,
                  // // text: o.title,
                  // textStyle: {
                  //   color: '#2577b1',
                  //   fontWeight: 'bold',
                  //   fontSize: 18
                  // }
                  // top: 0,
                  // bottom: 0,
                  // itemGap: 0
                },
                // tooltip: {
                //   show: true
                //   // formatter: '{b0}: {c0}'
                //   // formatter: function (params, ticket, callback) {
                //   //   console.log('formatter: ', params)
                //   //   callback(ticket, params.data[0] + 'ms:' + params.data)
                //   //   return params.data[0] + ' : ' + params.data[1]
                //   // }
                // },
                tooltip: {
                  // trigger: 'axis',
                  trigger: 'axis',
                  // formatter: '{c}人' // {b0}:
                  formatter: function (params, ticket, callback) {
                    callback(ticket, params[0].data[0] + ' ' + params[0].data)
                    return player.utils.timeFormat(params[0].data[0], true) + ' '+ params[0].data[1] + o.lang.person
                  },
                  backgroundColor: 'rgb(46, 164, 244)',
                  textStyle: {
                    color: 'rgb(255,255,255)'
                  },
                  axisPointer: {
                    snap: true,
                    lineStyle: {
                      color: 'rgba(128, 128, 128, 0.5)'
                    },
                    label: {
                      padding:1,
                      backgroundColor: 'rgb(46, 164, 244)',
                      textStyle: {
                        color: 'rgb(0, 0, 0)'
                      }
                    }
                  }

                  // axisPointer: {
                  //   type: 'cross',
                  //   label: {
                  //     backgroundColor: '#283b56'
                  //   }
                  // }
                },
                legend: {
                  show: false,
                  top: 0,
                  bottom: 0
                },
                // grid: {
                //   left: 0,
                //   top: 0,
                //   bottom: 0,
                //   right: 0
                // },
                // color: '#333',
                calculable: true,
                // dataZoom: {
                //   show: false,
                //   start: 0,
                //   end: 100
                // },
                toolbox: {
                  show: false
                },
                xAxis: {
                  show: false,
                  name: '',
                  // nameGap: 5,
                  type: 'category',
                  // type: 'category',
                  // nameRotate: 90,
                  axisLine: {
                    show: false,
                    onZero: true
                  },
                  axisLabel: {
                    show: false,
                    inside: true,
                    margin: 0
                  },
                  // data: currentArr,
                  min: 0,
                  max: duration,
                  data: newArr,
                  boundaryGap: [0, 0]
                  // splitNumber: 8,
                  // scale: false,
                  // min: 0,
                  // max: NUMBER_LIMIT,
                  // minInterval: 1,
                  // // interval: 0,
                  // axisLabel: {
                  //   rotate: 90
                  //   // formatter: function (value, index) {
                  //   //   return parseInt(value)
                  //   // }
                  // }
                },
                yAxis: {
                  show: false,
                  name: '',
                  axisLine: {
                    show: false,
                    onZero: true
                  },
                  axisLabel: {
                    show: false,
                    inside: true,
                    margin: 0
                  },
                  nameGap: 0,
                  type: 'value',
                  boundaryGap: [0, 0]
                  // nameGap: 5,
                  // // boundaryGap: [0, '10%'],
                  // splitNumber: 10,
                  // axisLine: {
                  //   show: false, onZero: false
                  // },
                  // minInterval: 1,
                  // // scale: true,
                  // axisLabel: {
                  //   inside: false,
                  //   margin: 5
                  //   // showMaxLabel: true
                  //   // formatter: function (value, index) {
                  //   //   return value + SENSORS_EXTENSION[this.type]
                  //   // }
                  //   // formatter: '{value}' + SENSORS_EXTENSION[that.type]
                  // },
                  // min: SENSORS_RANGE[this.type].min || null,
                  // max: SENSORS_RANGE[this.type].max || null
                },
                series: [{
                  name: '',
                  type: 'line',
                  // smooth: true,

                  showAllSymbol: true,
                  itemStyle: {
                      normal: {
                        color: 'rgb(226,176,69)',
                        borderColor: 'rgb(226,176,69)',
                        borderWidth: 2,
                        shadowBlur: 0
                      },
                      emphasis: {
                          // color: '#1e76b3'
                          color: 'rgb(226,176,69)',
                          borderColor: 'rgb(226,176,69)',
                          borderWidth: 4,
                          shadowBlur: 0
                      }
                  },
                  lineStyle: {
                    normal: {
                      color: 'rgb(30,118,178)'
                    },
                    emphasis: {
                      color: 'rgb(30,118,178)'
                    }
                  },

                  areaStyle: {
                      normal: {
                          color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                              offset: 0,
                              // color: '#2234b'
                              color: 'rgb(33,58,76)'
                          }, {
                              offset: 1,
                              color: 'rgb(31,103,152)'
                              // color: '#20587e'
                          }])
                      }
                  },
                    data: newArr,
                  // data: currentArr,
                  silent: false,
                  animation: false
                }]
              }

              console.log('meta newArr', newArr, echartOptions)

              if (echart) {
                echart.setOption(echartOptions)
                window.ec = echart
              }
              // echart.resize({width: 0, height: 0})
            }
          })
          var hide = function(w, h) {
            $wrapper.find('.activityhelper-title').hide()
            $wrapper.find('.activityhelper-panel .close-btn').hide()
            $wrapper.fadeOut().hide()
            if(echart) echart.resize({width: 0, height: 0})

          }
          var show = function(w, h) {
            if($wrapper) {


              $wrapper.find('.activityhelper-title').show()
              $wrapper.find('.activityhelper-panel .close-btn').show()

              $wrapper.css("width", w)
                .css("height", h * heightRadio)
                .css("bottom", o.grid.bottom || 0)
                .fadeIn(function(){
                  if(!echart) {
                    console.log(document.getElementById(o.id))
                    echart = echarts.init(document.getElementById(o.id), '', {width: _w, height: _h})
                    window.ec = echart
                    echart.on('click', function (params) {
                      console.log('click ', params)
                      player.seek(params.value[0])
                    })
                  }
                  if(echart) echart.resize({width: _w, height: _h * heightRadio *.8 })
              })
              var left = $("#"+player.id + " .jw-slider-time").position().left

              var tw = $("#"+player.id + " .jw-slider-time").width() * 1.01

              echartOptions = _.extend(echartOptions, {
                grid: {
                  // left: o.grid.left || 0,
                  show: false,
                  left: left - tw * 0.005,
                  z: 0,
                  width: tw,
                  top: 5,
                  // bottom: o.grid.bottom ||0,
                  bottom: 0,
                  // right: o.grid.right || 0,
                  // right: _w - of.left - w,
                  // width: '100%',
                  containLabel: true
                  // width: _w + 'px'
                  // width: '100%'
                }
              }, true)
              echart.setOption(echartOptions)
            }
          }
          this.resize = function(w, h) {

            console.log(_w,w, w/_w, _h, h, h/_h)
            if(showOrHide == 1) {
              if($wrapper) $wrapper.css("width", w).css("height", h * heightRadio).css("bottom", o.grid.bottom || 0)
              if(echart) {
                var left = $("#"+player.id + " .jw-slider-time").position().left

                var tw = $("#"+player.id + " .jw-slider-time").width() * 1.01
                console.log(" .jw-slider-time", tw)
                echartOptions = _.extend(echartOptions, {
                  grid: {
                    // left: o.grid.left || 0,
                    left: left - tw * 0.005,
                    width: tw,
                    z: 0,
                    top: 5,
                    bottom: 0,
                    // right: o.grid.right || 0,
                    // right: _w - of.left - w,
                    // width: '100%',
                    containLabel: true
                    // width: _w + 'px'
                    // width: '100%'
                  }
                }, true)
                echart.setOption(echartOptions)
                echart.resize({width: w, height: h * heightRadio *.8 })
              }
            } else {
              if(echart) echart.resize({width: 0, height: 0 })
            }

            _w = w;
            _h = h;
            player.addButton(buttonImg,
              o.dockname,
              function() {
                console.log('display: ', showOrHide)
                  showOrHide *= -1;
                  if(showOrHide == 1){
                      show(w, h)
                  }else{
                      hide(w, h)
                  }

              },
              pluginName);
          }

    });
    var buttonImg = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADIAAAAyCAYAAAAeP4ixAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAA4ZpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuNi1jMTM4IDc5LjE1OTgyNCwgMjAxNi8wOS8xNC0wMTowOTowMSAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wTU09Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9tbS8iIHhtbG5zOnN0UmVmPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvc1R5cGUvUmVzb3VyY2VSZWYjIiB4bWxuczp4bXA9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC8iIHhtcE1NOk9yaWdpbmFsRG9jdW1lbnRJRD0ieG1wLmRpZDo2ZTk5MGViMS0yMzNlLTQ3MmEtOThhNC0xMDE5ZWYyM2JhNzciIHhtcE1NOkRvY3VtZW50SUQ9InhtcC5kaWQ6M0RFQzlDRjBBQTcyMTFFN0E0RjhFQkE1NzBDODZDMDMiIHhtcE1NOkluc3RhbmNlSUQ9InhtcC5paWQ6M0RFQzlDRUZBQTcyMTFFN0E0RjhFQkE1NzBDODZDMDMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENDIDIwMTcgKE1hY2ludG9zaCkiPiA8eG1wTU06RGVyaXZlZEZyb20gc3RSZWY6aW5zdGFuY2VJRD0ieG1wLmlpZDo2ZTk5MGViMS0yMzNlLTQ3MmEtOThhNC0xMDE5ZWYyM2JhNzciIHN0UmVmOmRvY3VtZW50SUQ9ImFkb2JlOmRvY2lkOnBob3Rvc2hvcDo4NGY5ZTRkMi1mMmRhLTExN2EtYTQ0MC1kMzc5MWVhMmRhMWEiLz4gPC9yZGY6RGVzY3JpcHRpb24+IDwvcmRmOlJERj4gPC94OnhtcG1ldGE+IDw/eHBhY2tldCBlbmQ9InIiPz5ZQLJuAAABqklEQVR42uyYPUsDQRCGb/1C0gQM/gArIY1gKRHbFAopLK6wEMFCVBTS2NlbWKgoBGuxEmwEtRFsTGFhbcAfoK0GUVzfhTkcFvRcby/ehRl4SC47CfPs7B6bU1rroBuiJ+iSEBEREREREREREREREZHsiJijckU68n1s0yTZ5E6kDhrd0BEz+6vgIe8iJXABRuj6OY8iZdAEU9SZNRC67pG+lIorEE8xeVVwDIpU+DI4oLE9t8WptQsmKjE5A+AM3IGhH/LWwTv95gdYtMYHXWrzLdILTvRXNEHRyukHDZZjZOYd60hVxEgcsRlu0/trUKCcEriyJOaSSvgUUeCQFbgBquCVri/BOGhZEqEPCZ8iO6zAffZ5DbyxLkVhBGd9SfgS2WIFntIS4+Mh29SRRM2nhA+RTVbgDdsLNgvUESMx7VsiqUidSdyD4ZjvLtG+CdJAOT7ENsmTYAzsAgUewQRo5fEYXyaJFzDz3xJJjigr9HpO56QgryLRuUj+IWahI6Og3cEab3+T9Je7VqdDpdERldWlJQ/oRERERERERERERERERCQ2PgUYAOJjHGkBwxUNAAAAAElFTkSuQmCC"
});



//////////////////
// WEBPACK FOOTER
// ./src/webpack/activityhelper.js
// module id = 0
// module chunks = 0